import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ResultsProvider } from './context/ResultsContext';
import { AuthProvider } from './context/AuthContext';
import { PricingProvider } from './contexts/PricingContext';
import ProtectedRoute from './components/ProtectedRoute';
import SubscriptionRoute from './components/SubscriptionRoute';
import PlanSpecificRoute from './components/PlanSpecificRoute';
import ReconnectBrokerModal from './components/ReconnectBrokerModal';
import LandingPage from './NewLandingPage';
import AboutUsPage from './AboutUsPage';
import PricingPage from './PricingPage';
import ContactUsPage from './ContactUsPage';
import LoginPage from './LoginPage';
import SignupPage from './SignupPage';
import ForgotPasswordPage from './ForgotPasswordPage';
import ResetPasswordPage from './ResetPasswordPage';
import EmailVerificationPage from './pages/EmailVerificationPage';
import DashboardPage from './pages/DashboardPage';
import ProfilePage from './pages/ProfilePage';
import SettingsPage from './pages/SettingsPage';
import WatchlistPage from './pages/WatchlistPage';
import InvoicePage from './pages/InvoicePage';
import ResultsPage from './pages/ResultsPage';
import SearchResultsPage from './pages/SearchResultsPage';
import LongTermModelPage from './pages/LongTermModelPage';
import ShortTermModelPage from './pages/ShortTermModelPage';
import SwingModelPage from './pages/SwingModelPage';
import NewsPage from './pages/NewsPage';
import BlogsPage from './pages/BlogsPage';
import BlogPostPage from './pages/BlogPostPage';
import TutorialsPage from './pages/TutorialsPage';
import TestimonialSwiperDemo from './components/TestimonialSwiperDemo';
import ResultsSectionDemo from './components/ResultsSectionDemo';
import PricingSectionDemo from './components/PricingSectionDemo';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import RefundPage from './pages/RefundPage';
import RiskDisclaimerPage from './pages/RiskDisclaimerPage';
import PromptAnalysisPage from './pages/PromptAnalysisPage';
import BrokerIntegrationsPage from './pages/BrokerIntegrationsPage';
import ZerodhaCallbackPage from './pages/ZerodhaCallbackPage';
import ZerodhaOAuthStartPage from './pages/ZerodhaOAuthStartPage';
import ResultsHistoryPage from './pages/ResultsHistoryPage';
import PortfolioPage from './pages/PortfolioPage';
import OrdersPage from './pages/OrdersPage';
import FnoTraderPage from './pages/FnoTraderPage';
import NiftySignalAnalyzerPage from './pages/NiftySignalAnalyzerPage';
import NiftySignalPage from './pages/tools/NiftySignalPage';
import PatternPerformanceDashboard from './pages/tools/PatternPerformanceDashboard';
import NiftySignalHistoryPage from './pages/tools/NiftySignalHistoryPage';
import NiftySignalDashboardPage from './pages/tools/NiftySignalDashboardPage';
import NiftyAnalysisRunsPage from './pages/tools/NiftyAnalysisRunsPage';
import ReversalCandleLabelerPage from './pages/tools/ReversalCandleLabelerPage';
import UniversalPricePredictionPage from './pages/tools/UniversalPricePredictionPage';
import PricePredictionHistoryPage from './pages/tools/PricePredictionHistoryPage';
import CandleGapFillerPage from './pages/tools/CandleGapFillerPage';
import NiftyAnalyzerComparisonPage from './pages/NiftyAnalyzerComparisonPage';
import AutoTradeOrderHistoryPage from './pages/AutoTradeOrderHistoryPage';
import AutoTradePage from './pages/AutoTradePage';
import AuraDeviceManagementPage from './pages/AuraDeviceManagementPage';
import ElliottWavePage from './pages/ElliottWavePage';
import SharedZerodhaAdminPage from './pages/admin/SharedZerodhaAdminPage';

function App() {
  return (
    <Router>
      <AuthProvider>
        <PricingProvider>
          <ResultsProvider>
            <div className="App">
              {/* Global Broker Reconnect Modal */}
              <ReconnectBrokerModal />
            
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<LandingPage />} />
              <Route path="/about" element={<AboutUsPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/contact" element={<ContactUsPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/refund" element={<RefundPage />} />
              <Route path="/risk-disclaimer" element={<RiskDisclaimerPage />} />
              <Route path="/nifty-analyzer-comparison" element={<NiftyAnalyzerComparisonPage />} />
              <Route path="/nifty-signal" element={
                <ProtectedRoute>
                  <NiftySignalAnalyzerPage />
                </ProtectedRoute>
              } />
              <Route path="/tools/pattern-performance" element={
                <ProtectedRoute>
                  <PatternPerformanceDashboard />
                </ProtectedRoute>
              } />
              <Route path="/tools/nifty-signal-history" element={
                <ProtectedRoute>
                  <SubscriptionRoute>
                    <NiftySignalHistoryPage />
                  </SubscriptionRoute>
                </ProtectedRoute>
              } />
              <Route path="/tools/nifty-signal-dashboard" element={
                <ProtectedRoute>
                  <SubscriptionRoute>
                    <NiftySignalDashboardPage />
                  </SubscriptionRoute>
                </ProtectedRoute>
              } />
              <Route path="/tools/nifty-analysis-runs" element={
                <ProtectedRoute>
                  <SubscriptionRoute>
                    <NiftyAnalysisRunsPage />
                  </SubscriptionRoute>
                </ProtectedRoute>
              } />
              <Route path="/tools/reversal-candle-labeler" element={
                <ProtectedRoute>
                  <SubscriptionRoute>
                    <ReversalCandleLabelerPage />
                  </SubscriptionRoute>
                </ProtectedRoute>
              } />
              <Route path="/tools/nifty-ai-analyzer" element={
                <ProtectedRoute>
                  <SubscriptionRoute>
                    <NiftySignalPage />
                  </SubscriptionRoute>
                </ProtectedRoute>
              } />
              <Route path="/tools/price-prediction" element={
                <ProtectedRoute>
                  <SubscriptionRoute>
                    <UniversalPricePredictionPage />
                  </SubscriptionRoute>
                </ProtectedRoute>
              } />
              <Route path="/tools/price-prediction-history" element={
                <ProtectedRoute>
                  <SubscriptionRoute>
                    <PricePredictionHistoryPage />
                  </SubscriptionRoute>
                </ProtectedRoute>
              } />
              <Route path="/tools/candle-gap-filler" element={
                <ProtectedRoute>
                  <SubscriptionRoute>
                    <CandleGapFillerPage />
                  </SubscriptionRoute>
                </ProtectedRoute>
              } />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/blogs" element={<BlogsPage />} />
              <Route path="/blog/:id" element={<BlogPostPage />} />
              <Route path="/tutorials" element={<TutorialsPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/verify-email" element={<EmailVerificationPage />} />
              
              {/* Protected Routes */}
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              } />
              <Route path="/profile" element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              } />
              <Route path="/settings" element={
                <ProtectedRoute>
                  <SettingsPage />
                </ProtectedRoute>
              } />
              <Route path="/admin/shared-zerodha" element={
                <ProtectedRoute>
                  <SharedZerodhaAdminPage />
                </ProtectedRoute>
              } />
              <Route path="/watchlist" element={
                <ProtectedRoute>
                  <SubscriptionRoute>
                    <WatchlistPage />
                  </SubscriptionRoute>
                </ProtectedRoute>
              } />
              <Route path="/invoice" element={
                <ProtectedRoute>
                  <SubscriptionRoute>
                    <InvoicePage />
                  </SubscriptionRoute>
                </ProtectedRoute>
              } />
              <Route path="/broker-integrations" element={
                <ProtectedRoute>
                  <BrokerIntegrationsPage />
                </ProtectedRoute>
              } />
              <Route path="/portfolio" element={
                <ProtectedRoute>
                  <SubscriptionRoute>
                    <PortfolioPage />
                  </SubscriptionRoute>
                </ProtectedRoute>
              } />
              <Route path="/orders" element={
                <ProtectedRoute>
                  <SubscriptionRoute>
                    <OrdersPage />
                  </SubscriptionRoute>
                </ProtectedRoute>
              } />
              <Route path="/auto-trade" element={
                <ProtectedRoute>
                  <AutoTradePage />
                </ProtectedRoute>
              } />
              <Route path="/auto-trade-orders" element={
                <ProtectedRoute>
                  <SubscriptionRoute>
                    <AutoTradeOrderHistoryPage />
                  </SubscriptionRoute>
                </ProtectedRoute>
              } />
              <Route path="/aura-devices" element={
                <ProtectedRoute>
                  <SubscriptionRoute>
                    <AuraDeviceManagementPage />
                  </SubscriptionRoute>
                </ProtectedRoute>
              } />
              <Route path="/elliott-wave" element={
                <ProtectedRoute>
                  <SubscriptionRoute>
                    <ElliottWavePage />
                  </SubscriptionRoute>
                </ProtectedRoute>
              } />
              
              {/* F&O Momentum Trader (Protected) */}
              <Route path="/fno-trader-tool" element={
                <ProtectedRoute>
                  <FnoTraderPage />
                </ProtectedRoute>
              } />
              
              <Route path="/brokers/zerodha/callback" element={
                <ProtectedRoute>
                  <ZerodhaCallbackPage />
                </ProtectedRoute>
              } />
              <Route path="/brokers/zerodha/oauth-start" element={
                <ProtectedRoute>
                  <ZerodhaOAuthStartPage />
                </ProtectedRoute>
              } />
              <Route path="/results" element={
                <ProtectedRoute>
                  <SubscriptionRoute>
                    <ResultsPage />
                  </SubscriptionRoute>
                </ProtectedRoute>
              } />
              <Route path="/results-history" element={
                <ProtectedRoute>
                  <ResultsHistoryPage />
                </ProtectedRoute>
              } />
              <Route path="/search-results" element={
                <ProtectedRoute>
                  <SubscriptionRoute>
                    <SearchResultsPage />
                  </SubscriptionRoute>
                </ProtectedRoute>
              } />
              <Route path="/long-term-model" element={
                <ProtectedRoute>
                  <SubscriptionRoute>
                    <LongTermModelPage />
                  </SubscriptionRoute>
                </ProtectedRoute>
              } />
              <Route path="/short-term-model" element={
                <ProtectedRoute>
                  <PlanSpecificRoute requiredPlan="VECTOR PRO">
                    <ShortTermModelPage />
                  </PlanSpecificRoute>
                </ProtectedRoute>
              } />
              <Route path="/swing-model" element={
                <ProtectedRoute>
                  <PlanSpecificRoute requiredPlan="EXPERT">
                    <SwingModelPage />
                  </PlanSpecificRoute>
                </ProtectedRoute>
              } />
              <Route path="/ai-analyst" element={
                <ProtectedRoute>
                  <SubscriptionRoute>
                    <PromptAnalysisPage />
                  </SubscriptionRoute>
                </ProtectedRoute>
              } />
              <Route path="/news" element={
                <ProtectedRoute>
                  <SubscriptionRoute>
                    <NewsPage />
                  </SubscriptionRoute>
                </ProtectedRoute>
              } />
              
              {/* Demo Routes */}
              <Route path="/testimonial-demo" element={<TestimonialSwiperDemo />} />
              <Route path="/results-demo" element={<ResultsSectionDemo />} />
              <Route path="/pricing-demo" element={<PricingSectionDemo />} />
            </Routes>
          </div>
        </ResultsProvider>
        </PricingProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
